import { render, staticRenderFns } from "./hotspot-question-component.vue?vue&type=template&id=30fafa26&scoped=true&"
import script from "./hotspot-question-component.vue?vue&type=script&lang=ts&"
export * from "./hotspot-question-component.vue?vue&type=script&lang=ts&"
import style0 from "./hotspot-question-component.vue?vue&type=style&index=0&id=30fafa26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fafa26",
  null
  
)

export default component.exports